module.exports = __webpack_public_path__ + "static/media/airpods_dark.0869d81d.svg";